import { IconButton } from "@mui/material";
import { memo } from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";


const HTMLInput = ({ label, registeredParams, hiddenClear, isDanger, className, error, ...props }) => {
  return (
    <div className="floating-label-content position-relative" style={{ borderColor: isDanger ? "#f64e60" : "" }}>
      <input
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            const input = e.target;
            if (input?.disabled) return
            if (input) input.value = null;
            const ev = new Event("input", { bubbles: true });
            input.dispatchEvent(ev);
            e.stopPropagation()
          }
        }}
        className={`floating-input ${error && "border border-danger"} ${className}`}
        style={{ color: isDanger ? "#f64e60" : "" }}
        {...registeredParams}
        {...props}
        placeholder=""
      />
      {!hiddenClear &&
        <IconButton
          type="button"
          className="position-absolute ms-4 start-0 top-50 translate-middle w-auto"
          onClick={(e) => {
            const input = e.currentTarget.closest(".floating-label-content").querySelector("input");
            if (input?.disabled || input?.readOnly) return
            if (input) input.value = null;
            const ev = new Event("input", { bubbles: true });
            input.dispatchEvent(ev);
          }}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      <label className="floating-label" style={{ right: 5 }}>
        <span className={`opacity-70 ${error && "text-danger opacity-100"}`}>{label}</span>
      </label>
    </div>)
}

export default memo(HTMLInput)